import {
  AfterViewInit,
  Component,
  ElementRef,
  InjectionToken,
  OnDestroy,
  inject,
  output,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { Subscription, timer } from 'rxjs';
import { Icon } from '../icon/icon';
import { AlertMessageTypes } from './alert-message.types';

@Component({
  selector: 'app-alert-message',
  standalone: true,
  templateUrl: './alert-message.html',
  styleUrl: './alert-message.scss',
  imports: [Icon, NgClass],
})
export class AlertMessageComponent implements AfterViewInit, OnDestroy {
  private readonly el = inject(ElementRef);

  readonly alertMessage = inject<AlertMessageTypes>(
    'ALERT_MESSAGE_DATA' as unknown as InjectionToken<AlertMessageTypes>,
  );
  readonly timeOut = inject<number | null>(
    'TIME_OUT' as unknown as InjectionToken<number | null>,
  );

  readonly close = output({ alias: 'closeClick' });

  private openTimeOut: Subscription | undefined;
  private beforeCloseTimeOut: Subscription | undefined;
  private closeTimeOut: Subscription | undefined;

  closeMessage(): void {
    this.el.nativeElement.firstChild?.classList.remove('show');
    this.closeTimeOut = timer(200).subscribe(() => this.close.emit());
  }

  ngAfterViewInit(): void {
    this.openTimeOut = timer(200).subscribe(() =>
      this.el.nativeElement.firstChild?.classList.add('show'),
    );
    if (this.timeOut) {
      this.beforeCloseTimeOut = timer(this.timeOut).subscribe(() => this.closeMessage());
    }
  }

  ngOnDestroy(): void {
    this.openTimeOut?.unsubscribe();
    this.beforeCloseTimeOut?.unsubscribe();
    this.closeTimeOut?.unsubscribe();
  }
}
